'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCvAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.88109e-06 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -5.72404e-05 6.66667 8.88109e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 10.6667H28V0H8.88109e-06L0 10.6667Z",
          fill: "#0C49AE"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V14.6667H0V20Z",
          fill: "#0C49AE"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 14.6667H28V10.6667H0V14.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 13.3333H28V12H0V13.3333Z",
          fill: "#CD232E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6665 9.33335C10.5558 9.33335 10.4465 9.33873 10.3389 9.3492C9.9724 9.38487 9.64642 9.11671 9.61075 8.75025C9.57509 8.38379 9.84325 8.0578 10.2097 8.02214C10.3602 8.0075 10.5126 8.00002 10.6665 8.00002C10.8204 8.00002 10.9728 8.0075 11.1233 8.02214C11.4898 8.0578 11.7579 8.38379 11.7223 8.75025C11.6866 9.11671 11.3606 9.38487 10.9941 9.3492C10.8865 9.33873 10.7772 9.33335 10.6665 9.33335ZM8.644 9.15131C8.87773 9.43579 8.83659 9.85589 8.55211 10.0896C8.38323 10.2284 8.2282 10.3834 8.08945 10.5523C7.85571 10.8368 7.43561 10.8779 7.15113 10.6442C6.86664 10.4104 6.8255 9.99034 7.05924 9.70586C7.25312 9.46988 7.4697 9.2533 7.70567 9.05942C7.99016 8.82569 8.41026 8.86683 8.644 9.15131ZM12.689 9.15131C12.9228 8.86683 13.3429 8.82569 13.6273 9.05942C13.8633 9.2533 14.0799 9.46988 14.2738 9.70586C14.5075 9.99034 14.4664 10.4104 14.1819 10.6442C13.8974 10.8779 13.4773 10.8368 13.2436 10.5523C13.1048 10.3834 12.9498 10.2284 12.7809 10.0896C12.4964 9.85589 12.4553 9.43579 12.689 9.15131ZM6.75006 11.6109C7.11652 11.6466 7.38469 11.9726 7.34902 12.339C7.33855 12.4467 7.33317 12.5559 7.33317 12.6667C7.33317 12.7774 7.33855 12.8867 7.34902 12.9943C7.38469 13.3608 7.11652 13.6868 6.75006 13.7224C6.38361 13.7581 6.05762 13.4899 6.02196 13.1235C6.00731 12.973 5.99984 12.8206 5.99984 12.6667C5.99984 12.5128 6.00731 12.3604 6.02196 12.2099C6.05762 11.8434 6.38361 11.5753 6.75006 11.6109ZM14.5829 11.6109C14.9494 11.5753 15.2754 11.8434 15.3111 12.2099C15.3257 12.3604 15.3332 12.5128 15.3332 12.6667C15.3332 12.8206 15.3257 12.973 15.3111 13.1235C15.2754 13.4899 14.9494 13.7581 14.5829 13.7224C14.2165 13.6868 13.9483 13.3608 13.984 12.9943C13.9945 12.8867 13.9998 12.7774 13.9998 12.6667C13.9998 12.5559 13.9945 12.4467 13.984 12.339C13.9483 11.9726 14.2165 11.6466 14.5829 11.6109ZM7.15113 14.6892C7.43561 14.4555 7.85571 14.4966 8.08945 14.7811C8.2282 14.95 8.38323 15.105 8.55211 15.2437C8.83659 15.4775 8.87773 15.8976 8.64399 16.1821C8.41026 16.4665 7.99016 16.5077 7.70567 16.2739C7.4697 16.0801 7.25312 15.8635 7.05924 15.6275C6.8255 15.343 6.86664 14.9229 7.15113 14.6892ZM14.1819 14.6892C14.4664 14.9229 14.5075 15.343 14.2738 15.6275C14.0799 15.8635 13.8633 16.0801 13.6273 16.274C13.3429 16.5077 12.9227 16.4665 12.689 16.1821C12.4553 15.8976 12.4964 15.4775 12.7809 15.2437C12.9498 15.105 13.1048 14.95 13.2436 14.7811C13.4773 14.4966 13.8974 14.4555 14.1819 14.6892ZM9.61075 16.5831C9.64642 16.2167 9.9724 15.9485 10.3389 15.9842C10.4465 15.9946 10.5558 16 10.6665 16C10.7772 16 10.8865 15.9946 10.9941 15.9842C11.3606 15.9485 11.6866 16.2167 11.7223 16.5831C11.7579 16.9496 11.4898 17.2756 11.1233 17.3112C10.9728 17.3259 10.8204 17.3334 10.6665 17.3334C10.5126 17.3334 10.3602 17.3259 10.2097 17.3112C9.84325 17.2756 9.57509 16.9496 9.61075 16.5831Z",
          fill: "#F7D035"
        }
      )
    ]
  }
);
const VpFlagCvAsset = forwardRef(FlagCvAsset);

export { VpFlagCvAsset as default };
